export default __webpack_public_path__ + "static/media/post-schedule.621e0ab2.png";